import request from '@/router/axios'
//查询 账单管理列表
export function fetchFinanceList(query) {
  return request({
    url: '/financeManager/',
    method: 'post',
    params: query
  })
}

//统计今年付款情况
export function getProjectLedgersForYear(query) {
  return request({
    url: '/financeManager/getProjectLedgersForYear',
    method: 'post',
    params: query
  })
}

//发票包含项目列表
export function getProjects(query) {
  return request({
    url: '/financeManager/getProjects',
    method: 'post',
    params: query
  })
}

//导出账单管理
export function importProjectLedgers(query) {
  return request({
    url: '/financeManager/importProjectLedgers',
    method: 'post',
    params: query
  })
}

// 企业统计待开发票数
export function getProjectInvoiceCount(query) {
  return request({
    url: '/financeManager/getProjectInvoiceCount',
    method: 'post',
    params: query
  })
}

// 修改项目定价
export function updateProjectPrice(query) {
  return request({
    url: '/companyProject/updateProjectPrice',
    method: 'post',
    params: query
  })
}

//提交 修改额外费用补充说明
export function updateProjectExtraCostsCompanyTips(query) {
 return request({
   url: '/projectExecution/updateProjectExtraCostsCompanyTips',
   method: 'post',
   params: query
 })
}

//导出账单
export function exportProjectLedgers(query) {
 return request({
   url: '/financeManager/exportProjectLedgers',
   method: 'post',
   params: query,
   responseType: 'arraybuffer'
 })
}

//导出发票管理
export function exportInvoices(query) {
 return request({
   url: '/projectInvoice/exportInvoices',
   method: 'post',
   params: query,
   responseType: 'arraybuffer'
 })
}

//导出发票索取
export function exportInvoiceRequest(query) {
 return request({
   url: '/financeManager/exportInvoiceRequest',
   method: 'post',
   params: query,
   responseType: 'arraybuffer'
 })
}

